<div>
  <ul>
    @for (value of facet.values.slice(0, displayCount); track value) {
      <div>
        <li class="flex-row flex-center-start">
          <div class="flex-col">
            @if (showCheckboxes) {
              <input
                [checked]="value.selected"
                (change)="value.selected = !value.selected; notifyChanged()"
                type="checkbox"
              />
            }
          </div>
          {{ value.displayValue }} ({{ value.count }})
        </li>
      </div>
    }

    <li class="view-control">
      @if (displayCount < facet.values.length) {
        <span
          (click)="displayCount = facet.values.length"
        >+ View More</span
        >
      }
      @if (displayCount === facet.values.length) {
        <span (click)="displayCount = 5"
        >- View Less</span
        >
      }
    </li>
  </ul>
</div>
